import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import { observer } from 'mobx-react';
import { CloudUpload, Person } from '@mui/icons-material';
import { Avatar, Badge, Dialog, DialogActions, DialogContent, IconButton, Stack, styled } from '@mui/material';
import UserStore from '../../store/UserStore';
import AuthStore from '../../store/AuthStore';

export const BrowseProfilePictureDialog = observer(({ toggleDialog, handleDialog }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [isImageChanged, setIsImageChanged] = useState(false);

  useEffect(() => {
    setSelectedImage(UserStore.userImage);
  }, [UserStore.userImage]);

  useEffect(() => {
    setSelectedImage(UserStore.userImage);
    setIsImageChanged(false);
  }, [toggleDialog]);

  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });

  const SmallAvatar = styled(Avatar)(({ theme }) => ({
    width: 36,
    height: 36,
    border: `2px solid ${theme.palette.background.paper}`,
    backgroundColor: '#4c3a22',
    '& :hover': {
      backgroundColor: '#00000045',
    },
  }));

  const CustomAvatar = styled(Avatar)(({ theme }) => ({
    width: 200,
    height: 200,
    boxShadow:
      '0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)',
  }));

  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setIsImageChanged(true);
        setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUpdateImage = () => {
    UserStore.setUserImage(selectedImage ? selectedImage.split(',')[1] : null);
  };

  const handleRemoveImage = () => {
    setIsImageChanged(true);
    setSelectedImage(null);
  };

  useEffect(() => {
    if (UserStore.setUserImageStatus) {
      UserStore.fetchUserImage();
      handleDialog();
    }
  }, [UserStore.setUserImageStatus]);

  return (
    <Dialog
      open={toggleDialog}
      onClose={(event, reason) => reason !== 'backdropClick' && handleDialog()}
      fullWidth={true}
      maxWidth={'xs'}
    >
      {/* <DialogTitle sx={{fontWeight: '700'}}>Update Profile Picture</DialogTitle> */}
      <DialogContent>
        <Stack sx={{ py: '10px' }} alignItems={'center'}>
          <Badge
            overlap="circular"
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            badgeContent={
              <IconButton component="label" variant="contained">
                <SmallAvatar alt="Remy Sharp">
                  <CloudUpload />
                  <VisuallyHiddenInput type="file" accept="image/*" onChange={handleFileInputChange} />
                </SmallAvatar>
              </IconButton>
            }
          >
            {selectedImage ? (
              <CustomAvatar alt={AuthStore.userDetails.Name} src={selectedImage}></CustomAvatar>
            ) : (
              <CustomAvatar alt={AuthStore.userDetails.Name}>
                <Person sx={{ fontSize: 82 }}></Person>
              </CustomAvatar>
            )}
          </Badge>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="inherit" fullWidth onClick={handleDialog}>
          Cancel
        </Button>
        {selectedImage ? (
          <Button variant="contained" fullWidth color="error" onClick={handleRemoveImage}>
            Remove Image
          </Button>
        ) : (
          ''
        )}
        <Button
          variant="contained"
          disabled={!isImageChanged}
          fullWidth
          color="primary"
          autoFocus
          onClick={handleUpdateImage}
        >
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
});
